module.exports = "<div class=\"bottom-page-notification\"\n     ng-show=\"cookiePolicyCtrl.isNotificationVisible\">\n\n    <div class=\"text-m text-grey-3 child-link\" id=\"policyUrl\" translate=\"cw.cookie_policy\" translate-values=\"{website: webSite, brandname: brandName}\"></div>\n    <a class=\"icon icon-close icon-xxxs icon-grey-4 crs-pointer\" ng-click=\"cookiePolicyCtrl.closeNotification()\"\n        connectqa-cookie=\"close-cookie-notification\"></a>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/cookie-policy/cookie-policy.html
// module id = NH+E
// module chunks = 0